module.exports = __webpack_public_path__ + "static/media/sejo1.8b132d1a.png";